import { Divider, IconButton, InputAdornment } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, Select } from "../../../../controls";
import { Model, UseForm } from "../../../../hooks";
import { CloseRounded } from "@mui/icons-material";
import { action, API, controller } from "../../../../api/api";
import { useRef } from "react";
import { RmvEmptyProp, ToFormData } from "../../../../hooks/Method";
import { Form } from "../../../../layout";
import { AppContext } from "App";

const PayBalanceForm = ({
  setShowForm,
  setAlert,
  customerId,
  balance,
  setReloadKey,
  GetBalance,
}) => {
  const { CustomerTxnMdl } = Model();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(CustomerTxnMdl);
  const { settings } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [payMethods, setPayMethods] = useState([]);
  const [registers, setRegisters] = useState([]);
  const amountRef = useRef(null);

  useEffect(() => {
    // Focus on Amount Box
    amountRef.current.focus();

    // Get Payment  Types
    API(controller.PayType + action.GetAllByOrg).get((res) => {
      res && res.status === 200
        ? setPayMethods([...res.result.map((j) => ({ ...j, label: j.name }))])
        : console.error("Error: ", res);
    });

    // Get Registers
    API(controller.Register + action.GetAllByOrg).get((res) => {
      res && res.status === 200
        ? setRegisters([...res.result.map((j) => ({ ...j, label: j.name }))])
        : console.error("Error: ", res);
    });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValues((j) => ({
      ...j,
      customerId: customerId,
      amount: balance,
      payTypeId: payMethods[0] ? payMethods[0].id : "",
      registerId: registers[0] ? registers[0].id : "",
    }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registers]);

  const handleCancel = () => {
    setShowForm(false);
  };

  const validateForm = () => {
    let temp = {};
    temp.amount = values.amount !== "" ? "" : "Amount is required.";
    temp.payTypeId = values.payTypeId !== "" ? "" : "Payment type is required.";
    temp.registerId = values.registerId !== "" ? "" : "Register is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        setShowForm(false);
        if (res && (res.status === 201 || res.status === 200)) {
          GetBalance();
          setReloadKey((prevKey) => prevKey + 1);
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      API(controller.CustomerTxn + action.PayBalance).post(
        ToFormData(RmvEmptyProp({ ...values })),
        onComplete
      );
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="p-[10px] pb-[5px] flex items-center justify-between gap-1">
        <div>
          <span className="border-left text-[18px] font-medium text-gray-500">
            Pay account balance
          </span>
        </div>
        <div className="flex gap-2">
          <IconButton size="small" onClick={handleCancel}>
            <CloseRounded />
          </IconButton>
        </div>
      </div>
      <Divider />
      {/* Body */}
      <Form onSubmit={handleSubmit} noValidate>
        <div className="flex flex-col gap-[20px] p-[15px]">
          <p className="text-gray-500 mt-[15px] mb-[15px]">
            Your oldest account and layby/layaway sales will be paid off first.
            This will not automatically start integrated payment types.
          </p>
          <div>
            <Input
              label="Amount"
              name="amount"
              value={values.amount}
              error={errors.amount}
              required={true}
              onChange={handleInpChg}
              inputRef={amountRef}
              InputProps={{
                inputProps: {
                  className: "!font-medium !text-gray-500",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    {settings?.currSymbol || "$"}
                  </InputAdornment>
                ),
              }}
              onInput={(e) =>
                (e.target.value =
                  e.target.value <= balance ? e.target.value : values.amount)
              }
            />
          </div>
          <div>
            <Select
              label="Payment Type"
              name="payTypeId"
              value={values.payTypeId}
              error={errors.payTypeId}
              required={true}
              onChange={handleInpChg}
              options={[...payMethods]}
            />
          </div>
          <div>
            <Select
              label="Register"
              name="registerId"
              value={values.registerId}
              error={errors.registerId}
              required={true}
              onChange={handleInpChg}
              options={[...registers]}
            />
          </div>
          <div className="flex gap-3 justify-end">
            <Button onClick={handleCancel} size="large" variant="text">
              Cancel
            </Button>
            <Button type="submit" loading={loading} size="large">
              Pay balance
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default PayBalanceForm;
